<!--
  Eine Feldzeile im Raster, Label links und Wert rechts
  Trennlinien und Eckenrundung ergeben sich aus der Spalte und der Position im Raster
-->
<template>
  <div class="sidebar-field-row" :class="rowClasses">
    <div class="sidebar-field-row__label">
      <slot name="label">
        <component :is="icon" v-if="icon" :size="16" class="sidebar-field-row__icon" />
        <span>{{ label }}</span>
        <span
          v-if="saisonwert"
          class="sidebar-field-row__saison"
          v-b-tooltip.hover
          :title="`Saisonwert: ${saisonwert}`"
        >
          *
        </span>
      </slot>
    </div>
    <div class="sidebar-field-row__value">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarFieldRow',
  inject: {
    sidebarFieldColumns: { default: () => () => 1 },
  },
  props: {
    label: { type: String, default: '' },
    // Lucide-Komponente, wird links vor dem Label gezeigt
    icon: { type: [Object, Function], default: null },
    // Spalte im Grid, ab 1 gezählt
    column: { type: Number, default: 1 },
    // Nicht editierbare Zeile, wird grau hinterlegt
    readonly: { type: Boolean, default: false },
    // Wert wurde gegenüber dem Serverstand geändert
    changed: { type: Boolean, default: false },
    // Zeile über alle Spalten
    full: { type: Boolean, default: false },
    // Zeile mit zwei gleich breiten Hälften, die Wertespalte erhält eine feste Breite
    split: { type: Boolean, default: false },
    // Abweichender Saisonwert, wird als Hinweis am Label gezeigt
    saisonwert: { type: [String, Number], default: null },
    // Zeile in der untersten Rasterzeile, sie trägt keine Trennlinie und folgt der Kartenrundung
    last: { type: Boolean, default: false },
  },
  computed: {
    rowClasses() {
      return {
        'sidebar-field-row--readonly': this.readonly,
        'sidebar-field-row--changed': this.changed,
        'sidebar-field-row--full': this.full,
        'sidebar-field-row--split': this.split,
        'sidebar-field-row--divided': !this.full && this.column < this.sidebarFieldColumns(),
        'sidebar-field-row--last': this.last,
        'sidebar-field-row--last-left': this.last && (this.full || this.column === 1),
        'sidebar-field-row--last-right':
          this.last && (this.full || this.column === this.sidebarFieldColumns()),
      };
    },
  },
};
</script>

<style scoped>
.sidebar-field-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  padding: 6px 12px;
  border-bottom: 1px solid var(--border);
}
.sidebar-field-row--full {
  grid-column: 1 / -1;
}
.sidebar-field-row--divided {
  border-right: 1px solid var(--border);
}
.sidebar-field-row--last {
  border-bottom: none;
}
.sidebar-field-row--last-left {
  border-bottom-left-radius: var(--radius-md);
}
.sidebar-field-row--last-right {
  border-bottom-right-radius: var(--radius-md);
}
.sidebar-field-row--readonly {
  background-color: var(--surface-sunken);
}
.sidebar-field-row--changed {
  background-color: var(--primary-light);
}
.sidebar-field-row__label {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  color: var(--text-body);
  user-select: none;
}
.sidebar-field-row__icon {
  flex-shrink: 0;
  color: var(--text-subtle);
}
.sidebar-field-row__saison {
  color: var(--warning);
  cursor: default;
}
.sidebar-field-row__value {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex: 0 0 50%;
  min-width: 0;
  font-size: 13px;
  font-weight: 500;
  color: var(--text);
}
.sidebar-field-row--full .sidebar-field-row__value {
  flex: 1 1 auto;
}
.sidebar-field-row--full.sidebar-field-row--split .sidebar-field-row__value {
  flex: 0 0 50%;
}
</style>
